<template>
  <div class="timerFilter">
    <div class="pannelBox">
      <div class="form-group white">
        <label class="van-col--7">开始日期：</label>
        <div class="van-col--16">
          <input type="text" v-model="start_Time" placeholder="请选择开始日期" readonly
                 @click="onTimeShow('1')">
        </div>
      </div>
      <div class="form-group white">
        <label class="van-col--7">结束日期：</label>
        <div class="van-col--16">
          <input type="text" v-model="end_Time" placeholder="请选择结束日期" readonly
                 @click="onTimeShow('2')">
        </div>
      </div>
      <div class="submit">
        <van-button type="info" @click="onTimeChanel">重 置</van-button>
        <van-button type="primary" @click="onTimeConfirm">确 认</van-button>
      </div>
    </div>
    <!-- 日期 -->
    <van-popup v-model="timeShow" position="bottom">
      <van-datetime-picker
          v-model="currentDate"
          type="date"
          :max-date="maxDate"
          @confirm="timeConfirm"
          @cancel="timeShow=false"/>
    </van-popup>
  </div>
</template>

<script>
import {formatterDate} from '@/utils/publicFun';

export default {
  name: "timerFilter",
  props: ['startTime', 'endTime'],
  data() {
    return {
      start_Time: '',
      end_Time: '',
      currentDate: new Date(),
      maxDate: new Date(),
      timeShow: false
    }
  },
  created() {
    let now = formatterDate();
    this.start_Time = this.startTime || '';
    this.end_Time = this.endTime || '';
    // let minData = `${now.year - 1}-${now.month}-${now.day}`;
    let minData = `2016-01-01`;
    // 兼容ios
    let u = navigator.userAgent;
    if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) { // ios
      this.minDate = minData ? new Date(minData.replace(/\-/g, '/')) : new Date();
    } else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
      this.minDate = minData ? new Date(minData) : new Date();
    }
  },
  mounted() {
  },
  methods: {
    onTimeShow(w) { // 时间
      this.whichTime = w;
      this.timeShow = !this.timeShow;
    },
    timeConfirm(data) { // 确认选择时间
      let w = this.whichTime;
      let now = formatterDate(data);
      let time = now.year + '-' + now.month + '-' + now.day;
      if (w === '1') {
        this.start_Time = time;
      } else {
        this.end_Time = time;
      }
      this.timeShow = false;
    },
    getTimeData() { // 获取时间方法
      let time = {
        startTime: this.start_Time,
        endTime: this.end_Time
      }
      return time;
    },
    onTimeChanel() { // 点击重置时间
      this.start_Time = '';
      this.end_Time = '';
      this.$emit('changeTime');
    },
    onTimeConfirm() { // 点击时间确认
      let time = this.getTimeData();
      this.$emit('changeTime', time);
    }
  },
  components: {}
}
</script>

<style lang="stylus" scoped>
.timerFilter
  height 100%
  width 100%
  background #fff
  box-sizing border-box

  .form-group
    padding 0
    height 12vmin
    display flex
    line-height 12vmin
    font-size 4vmin
    overflow hidden
    border-bottom 1px solid #eee

    &:last-child
      border-bottom none

    &.noBorder
      border none

    label
      text-align left
      text-indent 6vmin
      display block

    input
      width 100%
      height 100%
      padding 0 3vmin
      font-size 4vmin
      border none
      vertical-align middle

  .form-group.white
    input
      background #fff

  /deep/ .van-overlay
    background transparent

  .submit
    margin 5vw 0 0 0
    height 10vw

    button
      height 100%
      width 50%
      margin 0
      font-size 4vw
      line-height inherit

</style>
